import React from 'react';
import '../styles/TechnicianCard.css';
import imgPrefix from '../imgConfig'; // 导入 imgConfig.js


const TechnicianCard = ({ distance, name, image, onClick, isSelected }) => {
  return (
    <div className={`technician-card-inner ${isSelected ? 'selected' : ''}`} onClick={onClick}>
      <img 
        src={`${imgPrefix}/${image}`}
        alt={name}
        style={{
          border: isSelected ? '3px solid #e60012' : '2px solid #f0f0f0',
          boxShadow: isSelected ? '0 0 10px rgba(230,0,18,0.3)' : '0 2px 5px rgba(0,0,0,0.2)'
        }}
      /> 
      <div className="technician-info">
        <span 
          className="technician-name"
          style={{
            color: isSelected ? '#e60012' : '#333'
          }}
        >
          {name}
        </span>
        <span className="technician-distance">{distance}</span>
      </div>
    </div>
  );
};

export default TechnicianCard;
